import { BookDataPair } from "./generateEditionData";

const BookData = ({ bookDataPair }: { bookDataPair: BookDataPair }) => {
  return (
    <p>
      <span className="font-bold">{bookDataPair.title}: </span>
      <span>{bookDataPair.value}</span>
    </p>
  );
};

export default BookData;
